const DEFAULT_KEFORMS_URL = "";
export const DEFAULT_STAFF_SERVICE_URL = "https://api.kontur.ru/staff";
const DEFAULT_PICKLIST_URL = "";
const DEFAULT_NIDUS_URL = "";
const DEFAULT_FSPRINTER_URL = "";
const DEFAULT_CONTRACTORS_URL = "";

export const defaultServicesUrls = {
    keformsUrl: DEFAULT_KEFORMS_URL,
    staffServiceUrl: DEFAULT_STAFF_SERVICE_URL,
    picklistUrl: DEFAULT_PICKLIST_URL,
    nidusUrl: DEFAULT_NIDUS_URL,
    fsPrinterUrl: DEFAULT_FSPRINTER_URL,
    contractorsApiUrl: DEFAULT_CONTRACTORS_URL,
};
